/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DashboardDto } from '../models/dashboard-dto';
import { dashboardsDashboardIdClonePost$Json } from '../fn/dashboards/dashboards-dashboard-id-clone-post-json';
import { DashboardsDashboardIdClonePost$Json$Params } from '../fn/dashboards/dashboards-dashboard-id-clone-post-json';
import { dashboardsDashboardIdClonePost$Plain } from '../fn/dashboards/dashboards-dashboard-id-clone-post-plain';
import { DashboardsDashboardIdClonePost$Plain$Params } from '../fn/dashboards/dashboards-dashboard-id-clone-post-plain';
import { dashboardsDashboardIdDelete } from '../fn/dashboards/dashboards-dashboard-id-delete';
import { DashboardsDashboardIdDelete$Params } from '../fn/dashboards/dashboards-dashboard-id-delete';
import { dashboardsDashboardIdGet$Json } from '../fn/dashboards/dashboards-dashboard-id-get-json';
import { DashboardsDashboardIdGet$Json$Params } from '../fn/dashboards/dashboards-dashboard-id-get-json';
import { dashboardsDashboardIdGet$Plain } from '../fn/dashboards/dashboards-dashboard-id-get-plain';
import { DashboardsDashboardIdGet$Plain$Params } from '../fn/dashboards/dashboards-dashboard-id-get-plain';
import { dashboardsDashboardIdPut$Json } from '../fn/dashboards/dashboards-dashboard-id-put-json';
import { DashboardsDashboardIdPut$Json$Params } from '../fn/dashboards/dashboards-dashboard-id-put-json';
import { dashboardsDashboardIdPut$Plain } from '../fn/dashboards/dashboards-dashboard-id-put-plain';
import { DashboardsDashboardIdPut$Plain$Params } from '../fn/dashboards/dashboards-dashboard-id-put-plain';
import { dashboardsDashboardIdTilesPost$Json } from '../fn/dashboards/dashboards-dashboard-id-tiles-post-json';
import { DashboardsDashboardIdTilesPost$Json$Params } from '../fn/dashboards/dashboards-dashboard-id-tiles-post-json';
import { dashboardsDashboardIdTilesPost$Plain } from '../fn/dashboards/dashboards-dashboard-id-tiles-post-plain';
import { DashboardsDashboardIdTilesPost$Plain$Params } from '../fn/dashboards/dashboards-dashboard-id-tiles-post-plain';
import { dashboardsGet$Json } from '../fn/dashboards/dashboards-get-json';
import { DashboardsGet$Json$Params } from '../fn/dashboards/dashboards-get-json';
import { dashboardsGet$Plain } from '../fn/dashboards/dashboards-get-plain';
import { DashboardsGet$Plain$Params } from '../fn/dashboards/dashboards-get-plain';
import { dashboardsPost$Json } from '../fn/dashboards/dashboards-post-json';
import { DashboardsPost$Json$Params } from '../fn/dashboards/dashboards-post-json';
import { dashboardsPost$Plain } from '../fn/dashboards/dashboards-post-plain';
import { DashboardsPost$Plain$Params } from '../fn/dashboards/dashboards-post-plain';
import { dashboardsTilesDashboardTileIdDelete } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-delete';
import { DashboardsTilesDashboardTileIdDelete$Params } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-delete';
import { dashboardsTilesDashboardTileIdPut$Json } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-put-json';
import { DashboardsTilesDashboardTileIdPut$Json$Params } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-put-json';
import { dashboardsTilesDashboardTileIdPut$Plain } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-put-plain';
import { DashboardsTilesDashboardTileIdPut$Plain$Params } from '../fn/dashboards/dashboards-tiles-dashboard-tile-id-put-plain';
import { DashboardTileDto } from '../models/dashboard-tile-dto';

@Injectable({ providedIn: 'root' })
export class DashboardsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dashboardsGet()` */
  static readonly DashboardsGetPath = '/dashboards';

  /**
   * List dashboards.
   *
   * Lists dashboards with optional search and tile details.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsGet$Plain$Response(params?: DashboardsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List dashboards.
   *
   * Lists dashboards with optional search and tile details.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsGet$Plain(params?: DashboardsGet$Plain$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

  /**
   * List dashboards.
   *
   * Lists dashboards with optional search and tile details.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsGet$Json$Response(params?: DashboardsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
    const obs = dashboardsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List dashboards.
   *
   * Lists dashboards with optional search and tile details.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsGet$Json(params?: DashboardsGet$Json$Params, context?: HttpContext): Observable<Array<DashboardDto>> {
    const resp = this.dashboardsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardDto>>): Array<DashboardDto> => r.body)
    );
  }

  /** Path part for operation `dashboardsPost()` */
  static readonly DashboardsPostPath = '/dashboards';

  /**
   * Create dashboard.
   *
   * Creates a new dashboard with optional tiles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsPost$Plain$Response(params?: DashboardsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create dashboard.
   *
   * Creates a new dashboard with optional tiles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsPost$Plain(params?: DashboardsPost$Plain$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /**
   * Create dashboard.
   *
   * Creates a new dashboard with optional tiles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsPost$Json$Response(params?: DashboardsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create dashboard.
   *
   * Creates a new dashboard with optional tiles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsPost$Json(params?: DashboardsPost$Json$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /** Path part for operation `dashboardsDashboardIdTilesPost()` */
  static readonly DashboardsDashboardIdTilesPostPath = '/dashboards/{dashboardId}/tiles';

  /**
   * Add tile to dashboard.
   *
   * Adds a new tile to an existing dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdTilesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdTilesPost$Plain$Response(params: DashboardsDashboardIdTilesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
    const obs = dashboardsDashboardIdTilesPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add tile to dashboard.
   *
   * Adds a new tile to an existing dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdTilesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdTilesPost$Plain(params: DashboardsDashboardIdTilesPost$Plain$Params, context?: HttpContext): Observable<DashboardTileDto> {
    const resp = this.dashboardsDashboardIdTilesPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardTileDto>): DashboardTileDto => r.body)
    );
  }

  /**
   * Add tile to dashboard.
   *
   * Adds a new tile to an existing dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdTilesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdTilesPost$Json$Response(params: DashboardsDashboardIdTilesPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
    const obs = dashboardsDashboardIdTilesPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Add tile to dashboard.
   *
   * Adds a new tile to an existing dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdTilesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdTilesPost$Json(params: DashboardsDashboardIdTilesPost$Json$Params, context?: HttpContext): Observable<DashboardTileDto> {
    const resp = this.dashboardsDashboardIdTilesPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardTileDto>): DashboardTileDto => r.body)
    );
  }

  /** Path part for operation `dashboardsDashboardIdGet()` */
  static readonly DashboardsDashboardIdGetPath = '/dashboards/{dashboardId}';

  /**
   * Get dashboard.
   *
   * Returns dashboard with optional tiles/visualization config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdGet$Plain$Response(params: DashboardsDashboardIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get dashboard.
   *
   * Returns dashboard with optional tiles/visualization config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdGet$Plain(params: DashboardsDashboardIdGet$Plain$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /**
   * Get dashboard.
   *
   * Returns dashboard with optional tiles/visualization config.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdGet$Json$Response(params: DashboardsDashboardIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get dashboard.
   *
   * Returns dashboard with optional tiles/visualization config.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdGet$Json(params: DashboardsDashboardIdGet$Json$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /** Path part for operation `dashboardsDashboardIdPut()` */
  static readonly DashboardsDashboardIdPutPath = '/dashboards/{dashboardId}';

  /**
   * Update dashboard.
   *
   * Updates dashboard name, description and tile layout.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdPut$Plain$Response(params: DashboardsDashboardIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update dashboard.
   *
   * Updates dashboard name, description and tile layout.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdPut$Plain(params: DashboardsDashboardIdPut$Plain$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /**
   * Update dashboard.
   *
   * Updates dashboard name, description and tile layout.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdPut$Json$Response(params: DashboardsDashboardIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update dashboard.
   *
   * Updates dashboard name, description and tile layout.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdPut$Json(params: DashboardsDashboardIdPut$Json$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /** Path part for operation `dashboardsDashboardIdDelete()` */
  static readonly DashboardsDashboardIdDeletePath = '/dashboards/{dashboardId}';

  /**
   * Delete dashboard.
   *
   * Soft-deletes a dashboard.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdDelete$Response(params: DashboardsDashboardIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = dashboardsDashboardIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete dashboard.
   *
   * Soft-deletes a dashboard.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsDashboardIdDelete(params: DashboardsDashboardIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.dashboardsDashboardIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardsTilesDashboardTileIdPut()` */
  static readonly DashboardsTilesDashboardTileIdPutPath = '/dashboards/tiles/{dashboardTileId}';

  /**
   * Update dashboard tile.
   *
   * Updates dashboard tile layout.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsTilesDashboardTileIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsTilesDashboardTileIdPut$Plain$Response(params: DashboardsTilesDashboardTileIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
    const obs = dashboardsTilesDashboardTileIdPut$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update dashboard tile.
   *
   * Updates dashboard tile layout.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsTilesDashboardTileIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsTilesDashboardTileIdPut$Plain(params: DashboardsTilesDashboardTileIdPut$Plain$Params, context?: HttpContext): Observable<DashboardTileDto> {
    const resp = this.dashboardsTilesDashboardTileIdPut$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardTileDto>): DashboardTileDto => r.body)
    );
  }

  /**
   * Update dashboard tile.
   *
   * Updates dashboard tile layout.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsTilesDashboardTileIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsTilesDashboardTileIdPut$Json$Response(params: DashboardsTilesDashboardTileIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardTileDto>> {
    const obs = dashboardsTilesDashboardTileIdPut$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update dashboard tile.
   *
   * Updates dashboard tile layout.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsTilesDashboardTileIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsTilesDashboardTileIdPut$Json(params: DashboardsTilesDashboardTileIdPut$Json$Params, context?: HttpContext): Observable<DashboardTileDto> {
    const resp = this.dashboardsTilesDashboardTileIdPut$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardTileDto>): DashboardTileDto => r.body)
    );
  }

  /** Path part for operation `dashboardsTilesDashboardTileIdDelete()` */
  static readonly DashboardsTilesDashboardTileIdDeletePath = '/dashboards/tiles/{dashboardTileId}';

  /**
   * Delete dashboard tile.
   *
   * Deletes a dashboard tile.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsTilesDashboardTileIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsTilesDashboardTileIdDelete$Response(params: DashboardsTilesDashboardTileIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = dashboardsTilesDashboardTileIdDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete dashboard tile.
   *
   * Deletes a dashboard tile.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsTilesDashboardTileIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardsTilesDashboardTileIdDelete(params: DashboardsTilesDashboardTileIdDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.dashboardsTilesDashboardTileIdDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `dashboardsDashboardIdClonePost()` */
  static readonly DashboardsDashboardIdClonePostPath = '/dashboards/{dashboardId}/clone';

  /**
   * Clone dashboard.
   *
   * Creates a copy of a dashboard, including its tiles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdClonePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdClonePost$Plain$Response(params: DashboardsDashboardIdClonePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdClonePost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Clone dashboard.
   *
   * Creates a copy of a dashboard, including its tiles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdClonePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdClonePost$Plain(params: DashboardsDashboardIdClonePost$Plain$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdClonePost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

  /**
   * Clone dashboard.
   *
   * Creates a copy of a dashboard, including its tiles.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardsDashboardIdClonePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdClonePost$Json$Response(params: DashboardsDashboardIdClonePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardDto>> {
    const obs = dashboardsDashboardIdClonePost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Clone dashboard.
   *
   * Creates a copy of a dashboard, including its tiles.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardsDashboardIdClonePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  dashboardsDashboardIdClonePost$Json(params: DashboardsDashboardIdClonePost$Json$Params, context?: HttpContext): Observable<DashboardDto> {
    const resp = this.dashboardsDashboardIdClonePost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardDto>): DashboardDto => r.body)
    );
  }

}
